import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { projectSettingsSpacePoliciesEntryPoint } from '@jira/spa-apps__project-settings-space-policies/src/projectSettingsSpacePoliciesEntryPoint.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getBusinessProjectResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { licenseDetailsResource_DEPRECATED_DO_NOT_USE } from '@jira/router-resources__business-license-details/src/useIsPremiumUserSeat.tsx';
import { coreProjectLayout } from '@jira/platform__layouts-core-project-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { projectSettingsCorePoliciesRoute } from '@jira/router-routes__project-settings-core-routes/src/projectSettingsCorePoliciesRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { getNavigationSidebarProjectSettingsResource } from './common/getNavigationSidebarProjectSettingsResource.tsx';

const projectSettingsSpacePoliciesPageEntryPoint = createPageEntryPoint({
	main: projectSettingsSpacePoliciesEntryPoint,
});

export const projectSettingsCorePoliciesRouteEntry: Route = createEntry(
	projectSettingsCorePoliciesRoute,
	() => ({
		group: 'project-settings-core',
		ufoName: 'project-settings.space-policies.jwm-tmp',
		layout: coreProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getNavigationResources(),
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			...getNavigationSidebarProjectSettingsResource(),
			...getBusinessProjectResources(),
			licenseDetailsResource_DEPRECATED_DO_NOT_USE,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},

		entryPoint: () =>
			fg('frontier-guided-autonomy-space-settings')
				? projectSettingsSpacePoliciesPageEntryPoint
				: notFoundPageEntrypoint,
	}),
);
